module.exports = __webpack_public_path__ + "static/rph2rph-illus-43283ca18104659f5c11fa7455c4144c.svg";